var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageCompliance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 39.966 33.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18773",
    "data-name": "Group 18773",
    transform: "translate(-2 -7.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35557",
    "data-name": "Path 35557",
    d: "M40.725,28.186a4.227,4.227,0,0,0-5.868,0l-5.1,4.969a3.993,3.993,0,0,0-3.11-1.492H14.788a7.435,7.435,0,0,0-4.629,1.625A4.752,4.752,0,0,1,7.2,34.327H3.332a1.332,1.332,0,1,0,0,2.664H7.2a7.435,7.435,0,0,0,4.629-1.625,4.752,4.752,0,0,1,2.964-1.039H26.644a1.331,1.331,0,0,1,1.312,1.112,1.082,1.082,0,0,0,.02.253,1.334,1.334,0,0,1-1.332,1.3H20.65a1.332,1.332,0,1,0,0,2.664h5.995a4,4,0,0,0,3.976-3.637l6.094-5.928a1.583,1.583,0,0,1,2.158,0,1.368,1.368,0,0,1,.047,1.952L29.388,42.2a6.8,6.8,0,0,1-4.955,2.118H3.332a1.332,1.332,0,0,0,0,2.664H24.426a9.485,9.485,0,0,0,6.9-2.957l9.531-10.157a4.025,4.025,0,0,0-.133-5.681Z",
    transform: "translate(0 -6.673)",
    fill: "#96006b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35558",
    "data-name": "Path 35558",
    d: "M16.33,21.66a1.307,1.307,0,0,0,.819-.286l8.392-6.594,3.164,3.164a1.336,1.336,0,0,0,1.845.04l7.087-6.541v2.238a1.332,1.332,0,0,0,2.664,0V8.352A1.336,1.336,0,0,0,38.97,7.02H33.641a1.332,1.332,0,0,0,0,2.664h1.978l-5.935,5.482-3.091-3.091a1.326,1.326,0,0,0-1.765-.107L15.5,19.3a1.329,1.329,0,0,0,.819,2.378Z",
    transform: "translate(-4.339)",
    fill: "#96006b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageCompliance);
export default __webpack_public_path__ + "static/media/manageCompliance.be58674cbe1a15ef3c963f3f14e7e970.svg";
export { ForwardRef as ReactComponent };